module.exports = __webpack_public_path__ + "static/nick-tat-b12d9774d3aa25cb1b2b56a2a0b558df.jpg";